<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dOMWFr/tc-custom/9780857907110.jpg?1726454431623" alt="This image is the cover for the book Para Handy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Para Handy
      </h1>
      <p class="bookDescription body article font2">
        <b>A collection of beloved short stories starring the Scottish seaman and his quirky crew.</b><br/>  <br/> Master mariner Para Handy, a.k.a. Peter Macfarlane, has been sailing his way into the affections of generations of Scots since he first weighed anchor in the pages of the <i>Glasgow Evening News</i> in 1905. He and his crew—Dougie the mate, Macphail the Engineer, Sunny Jim, and the Tar—all play their parts in evoking the irresistible atmosphere of a bygone age when puffers sailed between West Highland ports and the great city of Glasgow.<br/>  <br/> This definitive edition contains all three collections of short stories published in the author’s lifetime, as well as those that were unpublished, and a new story that was discovered in 2001. Extensive notes accompany each story, providing fascinating insights into colloquialisms, place-names, and historical events. This volume also includes a wealth of contemporary photographs, depicting the harbors, steamers, and puffers from the age of the <i>Vital Spark</i>.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Neil Munro, Brian D. Osborne, Ronald Armstrong
      </h2>
      
      <p class="authorDescription body article">Neil Munro (1863 - 1930), a native of Inveraray, was a journalist by profession and for many years was the editor of the Glasgow Evening News. He is best known for his comic tales about Para Handy, but he also produced a number of historical and contemporary novels, as well as poetry and non-fiction.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Birlinn Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0c9b9f9c